const newsletterForm = document.getElementById('newsletter-form')

async function postToGoogle() {
	const statusOutput = newsletterForm.querySelector('.status')
	const submitButton = newsletterForm.querySelector('input[type=submit]')
	submitButton.disabled = true
	submitButton.value = 'Submitting...'

	try {
		var body = new FormData(newsletterForm)
		const res = await fetch(
			'https://docs.google.com/forms/u/0/d/e/1FAIpQLSfJ4Zk7xqVBr6tlL7GWP5OPedGDGIs38fG3v0DNGJGvjxI0WA/formResponse',
			{
				method: 'POST',
				mode: 'no-cors',
				body,
			}
		)
		await res.text()
		newsletterForm.reset()
		submitButton.value = 'Submitted'
		statusOutput.classList.add('success')
		statusOutput.value = 'Thank you for signing up!'
	} catch {
		submitButton.value = 'Submit'
		statusOutput.classList.add('error')
		statusOutput.value = 'Sorry, there was an error signing up.'
	}
}

newsletterForm.addEventListener('submit', e => {
	e.preventDefault()
	postToGoogle()
})
